import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { FormBuilder, FormGroup } from '@angular/forms'
import { select, Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { SaveForm } from '@tokeet/tv3-platform'
import * as R from 'ramda'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { AddTagsToInquiry } from '@tv3/store/inquiry/inquiry-fields.actions'
import { Destroyable, untilDestroy } from '@tokeet/tv3-platform'
import { AddNewTags, LoadTags, selectTags } from '@tokeet/tv3-platform'

/* @todo - Squash rental, inquiry and guest tag management dialogs into single component */

@Component({
  selector: 'app-manage-tags-dialog',
  templateUrl: './manage-tags-dialog.component.html',
  host: { class: 'modal-content' },
  styleUrls: ['./manage-tags-dialog.component.scss'],
})
export class ManageTagsDialogComponent extends Destroyable implements OnInit {
  form = this.fb.group({
    tags: [[]],
  })

  tags: string[]

  constructor(
    public dialogRef: MatDialogRef<ManageTagsDialogComponent>,
    private router: Router,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { inquiry: Inquiry },
    private store: Store<fromRoot.State>
  ) {
    super()
  }

  ngOnInit() {
    this.store.dispatch(LoadTags())

    this.form.patchValue({ tags: R.pathOr([], ['inquiry', 'attributes', 'tags'], this.data) })

    this.store.pipe(select(selectTags('inquiry')), untilDestroy(this)).subscribe((tags) => {
      this.tags = this.processTags(tags)
    })
  }

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  onSave(form: FormGroup) {
    const formValues = form.getRawValue()
    const tags = this.processTags(formValues.tags)
    const newTags = this.processTags(R.filter((tag: string) => (this.tags || []).indexOf(tag) < 0, tags))
    this.store.dispatch(AddTagsToInquiry({ inquiry: this.data.inquiry, tags, newTags }))
    if (!R.isEmpty(newTags)) {
      this.store.dispatch(AddNewTags({ payload: { tags: newTags, type: 'inquiry' } }))
    }
    this.close()
  }

  addNewTag = (tag: string) => {
    return tag
  }

  private processTags(tags: string[]) {
    return R.map(R.pipe(R.when(R.is(Number), R.toString), R.toLower))(tags || [])
  }
}
